import { render, staticRenderFns } from "./safe-wwadd.vue?vue&type=template&id=55bbe815&scoped=true&"
import script from "./safe-wwadd.vue?vue&type=script&lang=js&"
export * from "./safe-wwadd.vue?vue&type=script&lang=js&"
import style0 from "./safe-wwadd.vue?vue&type=style&index=0&id=55bbe815&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bbe815",
  null
  
)

export default component.exports